import React, {
  useEffect, useReducer
} from 'react';

import {
  withRouter
} from 'react-router-dom';

import { Auth } from 'aws-amplify';

const authContext = React.createContext ();

const init = () => ({
  isDeserializing: true,
  isAuthenticating: false,
  needsConfirmation: false,
  loggedIn: false,
});

const authReducer = (state, {type, credentials, error}) => {
  switch (type) {
    case 'loginStart':
      return {...state, error:null, isAuthenticating: true}
    case 'deserialized':
      return {...state, isDeserializing: false}
    case 'login':
      return {...state, loggedIn: true, error: null, challenge: null, isAuthenticating: false, isDeserializing: false, credentials}
    case 'logout':
      return {...state, loggedIn: false}
    case 'error':
      switch (error.code) {
        case 'User is not confirmed.':
          return {...state, error, isAuthenticating: false}
        case 'NotAuthorizedException':
          return {...state, error, isAuthenticating: false}
        case 'InvalidPasswordException':
          return {...state, error,  isAuthenticating: false}
        case 'InvalidParameterException':
          return {...state, error, isAuthenticating: false}
        default:
          return {...state, error, isAuthenticating: false}
      }
      return {...state}
    case 'challenge':
      return {
        ...state,
        isAuthenticating: false,
        challenge: {
          challengeName: credentials.challengeName
        },
        credentials
      }
  }
}

const useAuth = () => {
  const [state, dispatch] = useReducer (authReducer, undefined, init);
  
  useEffect(() => {
    (async () => {
      if (!state.loggedIn && state.isDeserializing) {
        try {
          const credentials = await Auth.currentSession();
          dispatch({
            type: 'login',
            credentials
          })
        } catch (e) {
          dispatch({
            type: 'deserialized'
          })
        }
      }
    })()
  })

  const newPassword = async (password) => {
    try {
      dispatch({
        type: 'loginStart'
      })
      const credentials = await Auth.completeNewPassword(
        state.credentials,
        password
      )
      dispatch ({
        type: 'login',
        credentials
      })
    } catch (e) {
      dispatch({
        type:'error',
        error: e
      })
      throw e;
    }
  }

  const login = async (email, password) => {
    dispatch({
      type: 'loginStart'
    })
    try {
      const credentials = await Auth.signIn(email, password);
      if (credentials.challengeName) {
        dispatch({
          type: 'challenge',
          credentials
        })
      } else {
        dispatch({
          type: 'login',
          credentials
        })
      }
      return credentials
    } catch (e) {
      dispatch({
        type: 'error',
        error: e
      })
      throw e;
    }
  }

  const logout = async () => {
    await Auth.signOut();
    dispatch({
      type: 'logout'
    })
  }

  return [state, login, logout, newPassword];
}

const AuthProvider = withRouter((props) => {
  const {children, location, history } = props;
  const [state, login, logout, newPassword] = useAuth ();

  return <authContext.Provider value={{state, login, logout, newPassword}}>
    {children}
  </authContext.Provider>
})

export { AuthProvider, authContext }